import { render, staticRenderFns } from "./RelatedSettingPage.vue?vue&type=template&id=121ced72&"
import script from "./RelatedSettingPage.vue?vue&type=script&lang=js&"
export * from "./RelatedSettingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports